import { Arrow } from "../atoms/Arrow";
import { Eyebrow } from "../atoms/Eyebrow";
import { Reveal } from "../atoms/Reveal";
import type { Copy } from "../lib/copy";

type AutomationsProps = { t: Copy };

export function Automations({ t }: AutomationsProps) {
  return (
    <section id="automations" className="section automations">
      <div className="container">
        <div className="section-head wide">
          <Reveal>
            <Eyebrow>{t.automations.eyebrow}</Eyebrow>
          </Reveal>
          <Reveal as="h2" className="section-title" delay={60}>
            <span className="ink">{t.automations.title_a}</span>{" "}
            <span className="serif-accent">{t.automations.title_b}</span>
          </Reveal>
          <Reveal as="p" className="section-sub" delay={120}>
            {t.automations.sub}
          </Reveal>
        </div>

        <div className="auto-grid">
          {t.automations.items.map((a, i) => (
            <Reveal key={i} className="auto-card" delay={(i % 3) * 70}>
              <div className="ac-head">
                <span className="ac-tag">{a.tag}</span>
                <span className="ac-index">/{String(i + 1).padStart(2, "0")}</span>
              </div>
              <h3 className="ac-title">{a.title}</h3>
              <p className="ac-body">{a.body}</p>
              <div className="ac-foot">
                <span className="ac-dot" />
                <span className="ac-state">ready</span>
                <span className="ac-spacer" />
                <Arrow />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
